import React from "react";
import "../Slides/Slides.css";

function Slides({ slides, order, setOrder }) {
  const getSlideClass = (index) => {
    if (order === index) {
      return "slide active";
    } else {
      return "slide";
    }
  };

  return (
    <div className="slides-container">
      {slides.map((slide, index) => (
        <div
          onClick={() => setOrder(index)}
          key={index}
          className={getSlideClass(index)}
        >
          <p>{slide.title ? slide.title : slide.position}</p>
        </div>
      ))}
    </div>
  );
}

export default Slides;
